import React, {useEffect, useRef, useState} from 'react';
import {useTranslation} from 'react-i18next';
import Modal from '@components/modal/modal.component';
import { StyledModalContent } from '@components/modal/modal.style'
import {SecureStoragePlugin} from "capacitor-secure-storage-plugin";
import {IonToggle, ToggleCustomEvent} from "@ionic/react";
import {setPin, turnOffPin} from "@services/profile.service";
import PinModal, {PinModalConfiguration} from "@modals/sign/pin.component";
type AppApprovalsModalProps = {
    isOpen: boolean;
    onClose: () => void;
};

const AuthenticationSettingsModal: React.FC<AppApprovalsModalProps> = (props: AppApprovalsModalProps) => {

    const {t} = useTranslation();
    const pinRef = useRef<HTMLIonToggleElement>(null);

    const [pinLoginEnabled, setPinLoginEnabled] = useState<boolean>(false);
    const [showPinModal, setShowPinModal] = useState<boolean>(false);
    const [pinModalConfiguration, setPinModalConfiguration] = useState<PinModalConfiguration|null>();

    const handleClose = () => {
        props.onClose();

        setPinLoginEnabled(false);
    };

    useEffect(() => {
        handleOpen();
    });

    const handleOpen = () => {
        loadPinLoginEnabled();
    };

    useEffect(() => {
        loadPinLoginEnabled();
    }, []);

    const pinToggle = async (event: ToggleCustomEvent<{ checked: boolean }>) => {
        if (!event.detail.checked) {
            let pinLoginStorage = await SecureStoragePlugin.get({'key': 'pin_login_enabled'});
            if (pinLoginStorage && pinLoginStorage.value === '1') {
                await turnOffPin();
                await SecureStoragePlugin.set({
                    'key': 'pin_login_enabled',
                    'value': '0',
                });
            }
            setPinLoginEnabled(false);
        } else {
            setPinModalConfiguration({
                title: t("settingsTab.authentication.set_pin_title"),
                buttonText: t("settingsTab.authentication.set_pin_button"),
            });
            setShowPinModal(true);
        }
    };

    const savePin = async (code: string) => {
        await setPin(code);
        await SecureStoragePlugin.set({
            'key': 'pin_login_enabled',
            'value': '1',
        });

        setShowPinModal(false);
        setPinLoginEnabled(true);
    }

    const loadPinLoginEnabled = async () => {
        let pinLoginStorage = await SecureStoragePlugin.get({'key': 'pin_login_enabled'});

        if (pinLoginStorage && pinLoginStorage.value === '1') {
            setPinLoginEnabled(true);
        }
    };

    return (
        <>
            <Modal
                isOpen={props.isOpen}
                canDismiss={true}
                onDidDismiss={() => handleClose()}>
                <StyledModalContent>
                    <h1 className="title">{t("settingsTab.authentication.title")}</h1>
                    <div className="content">
                        <IonToggle
                            labelPlacement="end"
                            ref={pinRef}
                            checked={pinLoginEnabled}
                            onIonChange={(event) => pinToggle(event)}
                        >
                            {t("settingsTab.authentication.pinLoginEnabled")}
                        </IonToggle>
                    </div>
                </StyledModalContent>
            </Modal>

            {
                showPinModal && pinModalConfiguration &&
                <PinModal
                    configuration={pinModalConfiguration}
                    isOpen={showPinModal}
                    onSave={savePin}
                    onClose={() => {
                        setPinModalConfiguration(null)
                        setShowPinModal(false);
                    }}
                />
            }
        </>
    );
};

export default AuthenticationSettingsModal;